"use client";
import {useState} from "react";
import {FiSidebar} from "react-icons/fi";
import {GoArrowLeft} from "react-icons/go";
export const HitoryRoutePlan = function ({
  setIsHistoryTab
}: {
  setIsHistoryTab: (val: boolean) => void;
}) {
  //const [isHistoryTab, setIsHistoryTab] = useState(false);
  const [isHistDrawerOpen, setIsHistDrawerOpen] = useState(false);
  const routePlans = [
    {
      routeVersion: "Route Plan v1.2",
      date: "18 Jul 2025",
      time: "16:22",
      isCurrent: true,
      stats: {
        students: 54,
        vehicles: 5,
        duration: "42 min",
        distance: "25 km",
        maxWait: "8 min max wait"
      },
      output: {
        vehiclesUsed: 4,
        routesCreated: 10,
        busStops: 23,
        studentsMapped: 54
      }
    },
    {
      routeVersion: "Route Plan v1.2",
      date: "18 Jul 2025",
      time: "16:20",
      isCurrent: false,
      stats: {
        students: 54,
        vehicles: 5,
        duration: "30 min",
        distance: "20 km",
        maxWait: "5 min max wait"
      },
      output: {
        vehiclesUsed: 4,
        routesCreated: 10,
        busStops: 23,
        studentsMapped: 54
      }
    },
    {
      routeVersion: "Route Plan v1.2",
      date: "18 Jul 2025",
      time: "16:15",
      isCurrent: false,
      stats: {
        students: 52,
        vehicles: 4,
        duration: "35 min",
        distance: "22 km",
        maxWait: "6 min max wait"
      },
      output: {
        vehiclesUsed: 4,
        routesCreated: 9,
        busStops: 21,
        studentsMapped: 52
      }
    }
  ];
  return (
    <div className="absolute left-4 top-2 z-10 w-96 rounded bg-white bg-opacity-90 p-2 shadow-md">
      <div className="flex items-center justify-between border-b px-4 py-2">
        {/* Title */}
        <div className="flex items-center space-x-3">
          <button
            title="View History"
            className="text-gray-600 hover:text-gray-800"
            onClick={() => setIsHistoryTab(false)}
          >
            <GoArrowLeft className="h-5 w-5" />
          </button>
          <h2 className="text-sm font-semibold text-gray-700">
            Planning Route History
          </h2>
        </div>

        {/* Action Icons */}
        <div className="flex items-center space-x-3">
          <button
            title="Open Drawer"
            className="text-gray-600 hover:text-gray-800"
            onClick={() => setIsHistDrawerOpen(!isHistDrawerOpen)}
          >
            <FiSidebar className="h-5 w-5" />
          </button>
        </div>
      </div>
      {isHistDrawerOpen && (
        <div className="max-h-[400px] space-y-4 overflow-y-auto pr-2">
          <div className="flex flex-col">
            <div className="space-y-4">
              {routePlans.map((plan, index) => (
                <div
                  key={index}
                  className="rounded-xl border bg-white p-4 shadow-sm"
                >
                  {/* Header */}
                  <div className="flex items-start justify-between">
                    <div className="gap-2 border-b pb-1 pt-1">
                      <h2 className="text-sm font-semibold text-gray-800">
                        Morning Route Plan {plan.routeVersion}
                      </h2>
                      <div className="flex items-center">
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 15 15"
                          fill="currentColor"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_8110_13542)">
                            <g clip-path="url(#clip1_8110_13542)">
                              <path
                                d="M7.5731 0.389648C9.48527 0.389648 11.3191 1.14925 12.6712 2.50136C14.0233 3.85346 14.7829 5.68731 14.7829 7.59947C14.7829 9.51163 14.0233 11.3455 12.6712 12.6976C11.3191 14.0497 9.48527 14.8093 7.5731 14.8093C5.66094 14.8093 3.82709 14.0497 2.47499 12.6976C1.12289 11.3455 0.363281 9.51163 0.363281 7.59947C0.363281 5.68731 1.12289 3.85346 2.47499 2.50136C3.82709 1.14925 5.66094 0.389648 7.5731 0.389648ZM6.89718 3.76925V7.59947C6.89718 7.82478 7.00984 8.036 7.19853 8.16274L9.90221 9.96519C10.212 10.1736 10.6316 10.0891 10.8401 9.7765C11.0485 9.46388 10.964 9.04707 10.6514 8.83866L8.24902 7.23898V3.76925C8.24902 3.39468 7.94768 3.09333 7.5731 3.09333C7.19853 3.09333 6.89718 3.39468 6.89718 3.76925Z"
                                fill="currentColor"
                                className="text-gray-500"
                              />
                            </g>
                          </g>
                          <defs>
                            <clipPath id="clip0_8110_13542">
                              <rect
                                width="14.4196"
                                height="14.4196"
                                fill="white"
                                transform="translate(0.363281 0.389648)"
                              />
                            </clipPath>
                            <clipPath id="clip1_8110_13542">
                              <path
                                d="M0.363281 0.389648H14.7829V14.8093H0.363281V0.389648Z"
                                fill="white"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <p className="text-xs text-gray-500">
                          {plan.date}, {plan.time}
                        </p>
                      </div>
                    </div>
                    {plan.isCurrent && (
                      <span className="rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-600">
                        Current
                      </span>
                    )}
                  </div>

                  {/* Stats */}
                  <div className="mt-3 grid grid-cols-2 gap-y-1 text-sm text-gray-700">
                    <div className="flex items-center gap-2">
                      <svg
                        width="19"
                        height="16"
                        viewBox="0 0 19 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_8110_13528)">
                          <g clip-path="url(#clip1_8110_13528)">
                            <path
                              d="M4.41881 0.898438C5.01636 0.898438 5.58943 1.13581 6.01197 1.55835C6.4345 1.98088 6.67188 2.55396 6.67188 3.15151C6.67188 3.74906 6.4345 4.32213 6.01197 4.74467C5.58943 5.1672 5.01636 5.40458 4.41881 5.40458C3.82125 5.40458 3.24818 5.1672 2.82565 4.74467C2.40311 4.32213 2.16574 3.74906 2.16574 3.15151C2.16574 2.55396 2.40311 1.98088 2.82565 1.55835C3.24818 1.13581 3.82125 0.898438 4.41881 0.898438ZM14.7829 0.898438C15.3805 0.898438 15.9536 1.13581 16.3761 1.55835C16.7986 1.98088 17.036 2.55396 17.036 3.15151C17.036 3.74906 16.7986 4.32213 16.3761 4.74467C15.9536 5.1672 15.3805 5.40458 14.7829 5.40458C14.1854 5.40458 13.6123 5.1672 13.1898 4.74467C12.7672 4.32213 12.5299 3.74906 12.5299 3.15151C12.5299 2.55396 12.7672 1.98088 13.1898 1.55835C13.6123 1.13581 14.1854 0.898438 14.7829 0.898438ZM0.363281 9.31083C0.363281 7.65201 1.70949 6.3058 3.36831 6.3058H4.57089C5.01869 6.3058 5.44395 6.40438 5.82697 6.57899C5.79036 6.78176 5.77346 6.99299 5.77346 7.20703C5.77346 8.28287 6.24661 9.24887 6.99294 9.91071C6.9873 9.91071 6.98167 9.91071 6.97322 9.91071H0.963161C0.63365 9.91071 0.363281 9.64035 0.363281 9.31083ZM11.7779 9.91071C11.7723 9.91071 11.7666 9.91071 11.7582 9.91071C12.5073 9.24887 12.9777 8.28287 12.9777 7.20703C12.9777 6.99299 12.9579 6.78458 12.9241 6.57899C13.3072 6.40156 13.7324 6.3058 14.1802 6.3058H15.3828C17.0416 6.3058 18.3878 7.65201 18.3878 9.31083C18.3878 9.64316 18.1175 9.91071 17.788 9.91071H11.7779ZM6.67188 7.20703C6.67188 6.48997 6.95673 5.80228 7.46377 5.29524C7.9708 4.7882 8.6585 4.50335 9.37556 4.50335C10.0926 4.50335 10.7803 4.7882 11.2874 5.29524C11.7944 5.80228 12.0792 6.48997 12.0792 7.20703C12.0792 7.92409 11.7944 8.61178 11.2874 9.11882C10.7803 9.62586 10.0926 9.91071 9.37556 9.91071C8.6585 9.91071 7.9708 9.62586 7.46377 9.11882C6.95673 8.61178 6.67188 7.92409 6.67188 7.20703ZM3.96819 14.5661C3.96819 12.4933 5.64954 10.8119 7.72237 10.8119H11.0287C13.1016 10.8119 14.7829 12.4933 14.7829 14.5661C14.7829 14.9801 14.4478 15.3181 14.031 15.3181H4.72015C4.30615 15.3181 3.96819 14.9829 3.96819 14.5661Z"
                              fill="#FFB800"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_8110_13528">
                            <rect
                              width="18.0246"
                              height="14.4196"
                              fill="white"
                              transform="translate(0.363281 0.898438)"
                            />
                          </clipPath>
                          <clipPath id="clip1_8110_13528">
                            <path
                              d="M0.363281 0.898438H18.3878V15.3181H0.363281V0.898438Z"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <p className="text-sm font-bold">
                        {plan.stats.students} Students
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      <svg
                        width="17"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_8110_13535)">
                          <g clip-path="url(#clip1_8110_13535)">
                            <path
                              d="M8.76841 0.898438C12.5536 0.898438 15.077 1.88979 15.077 3.15151V3.60212V4.50335C15.5755 4.50335 15.9782 4.90608 15.9782 5.40458V7.20703C15.9782 7.70552 15.5755 8.10826 15.077 8.10826V12.6144C15.077 13.1129 14.6743 13.5156 14.1758 13.5156V14.4169C14.1758 14.9153 13.773 15.3181 13.2746 15.3181H12.3733C11.8748 15.3181 11.4721 14.9153 11.4721 14.4169V13.5156H6.06473V14.4169C6.06473 14.9153 5.662 15.3181 5.1635 15.3181H4.26228C3.76379 15.3181 3.36105 14.9153 3.36105 14.4169V13.5156C2.86256 13.5156 2.45982 13.1129 2.45982 12.6144V8.10826C1.96133 8.10826 1.55859 7.70552 1.55859 7.20703V5.40458C1.55859 4.90608 1.96133 4.50335 2.45982 4.50335V3.60212V3.15151C2.45982 1.88979 4.98326 0.898438 8.76841 0.898438ZM4.26228 5.40458V8.10826C4.26228 8.60675 4.66501 9.00949 5.1635 9.00949H8.3178V4.50335H5.1635C4.66501 4.50335 4.26228 4.90608 4.26228 5.40458ZM9.21903 9.00949H12.3733C12.8718 9.00949 13.2746 8.60675 13.2746 8.10826V5.40458C13.2746 4.90608 12.8718 4.50335 12.3733 4.50335H9.21903V9.00949ZM4.71289 12.1638C4.95191 12.1638 5.18114 12.0688 5.35015 11.8998C5.51917 11.7308 5.61412 11.5016 5.61412 11.2626C5.61412 11.0235 5.51917 10.7943 5.35015 10.6253C5.18114 10.4563 4.95191 10.3613 4.71289 10.3613C4.47387 10.3613 4.24464 10.4563 4.07563 10.6253C3.90661 10.7943 3.81166 11.0235 3.81166 11.2626C3.81166 11.5016 3.90661 11.7308 4.07563 11.8998C4.24464 12.0688 4.47387 12.1638 4.71289 12.1638ZM12.8239 12.1638C13.063 12.1638 13.2922 12.0688 13.4612 11.8998C13.6302 11.7308 13.7252 11.5016 13.7252 11.2626C13.7252 11.0235 13.6302 10.7943 13.4612 10.6253C13.2922 10.4563 13.063 10.3613 12.8239 10.3613C12.5849 10.3613 12.3557 10.4563 12.1867 10.6253C12.0177 10.7943 11.9227 11.0235 11.9227 11.2626C11.9227 11.5016 12.0177 11.7308 12.1867 11.8998C12.3557 12.0688 12.5849 12.1638 12.8239 12.1638ZM11.4721 3.15151C11.4721 2.90367 11.2693 2.70089 11.0215 2.70089H6.51535C6.26751 2.70089 6.06473 2.90367 6.06473 3.15151C6.06473 3.39934 6.26751 3.60212 6.51535 3.60212H11.0215C11.2693 3.60212 11.4721 3.39934 11.4721 3.15151Z"
                              fill="#FFB800"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_8110_13535">
                            <rect
                              width="16.2221"
                              height="14.4196"
                              fill="white"
                              transform="translate(0.65625 0.898438)"
                            />
                          </clipPath>
                          <clipPath id="clip1_8110_13535">
                            <path
                              d="M0.65625 0.898438H16.8783V15.3181H0.65625V0.898438Z"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>

                      <p className="text-sm font-bold">
                        {plan.stats.vehicles} Vehicles
                      </p>
                    </div>
                    <div className="flex items-center gap-2">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_8110_13542)">
                          <g clip-path="url(#clip1_8110_13542)">
                            <path
                              d="M7.5731 0.389648C9.48527 0.389648 11.3191 1.14925 12.6712 2.50136C14.0233 3.85346 14.7829 5.68731 14.7829 7.59947C14.7829 9.51163 14.0233 11.3455 12.6712 12.6976C11.3191 14.0497 9.48527 14.8093 7.5731 14.8093C5.66094 14.8093 3.82709 14.0497 2.47499 12.6976C1.12289 11.3455 0.363281 9.51163 0.363281 7.59947C0.363281 5.68731 1.12289 3.85346 2.47499 2.50136C3.82709 1.14925 5.66094 0.389648 7.5731 0.389648ZM6.89718 3.76925V7.59947C6.89718 7.82478 7.00984 8.036 7.19853 8.16274L9.90221 9.96519C10.212 10.1736 10.6316 10.0891 10.8401 9.7765C11.0485 9.46388 10.964 9.04707 10.6514 8.83866L8.24902 7.23898V3.76925C8.24902 3.39468 7.94768 3.09333 7.5731 3.09333C7.19853 3.09333 6.89718 3.39468 6.89718 3.76925Z"
                              fill="#FFB800"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_8110_13542">
                            <rect
                              width="14.4196"
                              height="14.4196"
                              fill="white"
                              transform="translate(0.363281 0.389648)"
                            />
                          </clipPath>
                          <clipPath id="clip1_8110_13542">
                            <path
                              d="M0.363281 0.389648H14.7829V14.8093H0.363281V0.389648Z"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <p className="text-sm font-bold">{plan.stats.duration}</p>
                    </div>
                    <div className="flex items-center gap-2">
                      <svg
                        width="16"
                        height="15"
                        viewBox="0 0 16 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_8110_13549)">
                          <g clip-path="url(#clip1_8110_13549)">
                            <path
                              d="M15.0759 3.09333C15.0759 4.50713 13.4114 6.61657 12.6933 7.45865C12.5863 7.58257 12.4285 7.63045 12.2849 7.59947H9.66853C9.17004 7.59947 8.7673 8.00221 8.7673 8.5007C8.7673 8.99919 9.17004 9.40193 9.66853 9.40193H12.3722C13.8649 9.40193 15.0759 10.6129 15.0759 12.1056C15.0759 13.5983 13.8649 14.8093 12.3722 14.8093H4.58786C4.83288 14.5305 5.13141 14.1728 5.43276 13.7729C5.61019 13.5363 5.79325 13.2772 5.96786 13.0068H12.3722C12.8707 13.0068 13.2734 12.6041 13.2734 12.1056C13.2734 11.6071 12.8707 11.2044 12.3722 11.2044H9.66853C8.17587 11.2044 6.96484 9.99336 6.96484 8.5007C6.96484 7.00804 8.17587 5.79701 9.66853 5.79701H10.7894C10.198 4.90987 9.66853 3.89035 9.66853 3.09333C9.66853 1.60067 10.8796 0.389648 12.3722 0.389648C13.8649 0.389648 15.0759 1.60067 15.0759 3.09333ZM3.95418 14.1643C3.84716 14.2855 3.7514 14.3925 3.66973 14.4826L3.61904 14.5389L3.6134 14.5333C3.44442 14.6628 3.20222 14.6459 3.05014 14.4826C2.34042 13.7109 0.65625 11.7254 0.65625 10.3032C0.65625 8.81049 1.86727 7.59947 3.35993 7.59947C4.85259 7.59947 6.06362 8.81049 6.06362 10.3032C6.06362 11.1481 5.46937 12.1901 4.83851 13.0603C4.53716 13.4743 4.22736 13.8489 3.97108 14.1446L3.95418 14.1643ZM4.26116 10.3032C4.26116 10.0641 4.16621 9.8349 3.9972 9.66589C3.82818 9.49688 3.59895 9.40193 3.35993 9.40193C3.12091 9.40193 2.89168 9.49688 2.72267 9.66589C2.55366 9.8349 2.45871 10.0641 2.45871 10.3032C2.45871 10.5422 2.55366 10.7714 2.72267 10.9404C2.89168 11.1094 3.12091 11.2044 3.35993 11.2044C3.59895 11.2044 3.82818 11.1094 3.9972 10.9404C4.16621 10.7714 4.26116 10.5422 4.26116 10.3032ZM12.3722 3.99456C12.6112 3.99456 12.8405 3.89961 13.0095 3.7306C13.1785 3.56158 13.2734 3.33235 13.2734 3.09333C13.2734 2.85431 13.1785 2.62508 13.0095 2.45607C12.8405 2.28705 12.6112 2.1921 12.3722 2.1921C12.1332 2.1921 11.904 2.28705 11.7349 2.45607C11.5659 2.62508 11.471 2.85431 11.471 3.09333C11.471 3.33235 11.5659 3.56158 11.7349 3.7306C11.904 3.89961 12.1332 3.99456 12.3722 3.99456Z"
                              fill="#FFB800"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_8110_13549">
                            <rect
                              width="14.4196"
                              height="14.4196"
                              fill="white"
                              transform="translate(0.65625 0.389648)"
                            />
                          </clipPath>
                          <clipPath id="clip1_8110_13549">
                            <path
                              d="M0.65625 0.389648H15.0759V14.8093H0.65625V0.389648Z"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <p className="text-sm font-bold">{plan.stats.distance}</p>
                    </div>
                    <div className="col-span-2 flex items-center gap-2">
                      <svg
                        width="12"
                        height="16"
                        viewBox="0 0 12 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_8110_13556)">
                          <g clip-path="url(#clip1_8110_13556)">
                            <path
                              d="M1.26451 0.880371C0.766017 0.880371 0.363281 1.28311 0.363281 1.7816C0.363281 2.28009 0.766017 2.68283 1.26451 2.68283V2.99262C1.26451 4.18675 1.74047 5.333 2.58537 6.1779L4.49485 8.09019L2.58537 10.0025C1.74047 10.8474 1.26451 11.9936 1.26451 13.1878V13.4976C0.766017 13.4976 0.363281 13.9003 0.363281 14.3988C0.363281 14.8973 0.766017 15.3 1.26451 15.3H2.16574H9.37556H10.2768C10.7753 15.3 11.178 14.8973 11.178 14.3988C11.178 13.9003 10.7753 13.4976 10.2768 13.4976V13.1878C10.2768 11.9936 9.80083 10.8474 8.95592 10.0025L7.04645 8.09019L8.95874 6.1779C9.80364 5.333 10.2796 4.18675 10.2796 2.99262V2.68283C10.7781 2.68283 11.1808 2.28009 11.1808 1.7816C11.1808 1.28311 10.7781 0.880371 10.2796 0.880371H9.37556H2.16574H1.26451ZM3.06696 2.99262V2.68283H8.47433V2.99262C8.47433 3.52773 8.31662 4.04593 8.02372 4.48528H3.51758C3.2275 4.04593 3.06696 3.52773 3.06696 2.99262ZM3.51758 11.6951C3.61615 11.5458 3.73162 11.405 3.85836 11.2755L5.77065 9.36599L7.68294 11.2783C7.81249 11.4078 7.92515 11.5487 8.02372 11.6979H3.51758V11.6951Z"
                              fill="#FFB800"
                            />
                          </g>
                        </g>
                        <defs>
                          <clipPath id="clip0_8110_13556">
                            <rect
                              width="10.8147"
                              height="14.4196"
                              fill="white"
                              transform="translate(0.363281 0.880371)"
                            />
                          </clipPath>
                          <clipPath id="clip1_8110_13556">
                            <path
                              d="M0.363281 0.880371H11.178V15.3H0.363281V0.880371Z"
                              fill="white"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <p className="text-sm font-bold">{plan.stats.maxWait}</p>
                    </div>
                  </div>

                  {/* Show Details Button */}
                  {/* <div className="mt-3 text-right">
                    <button className="text-sm font-medium text-blue-600 hover:underline">
                      Show Details
                    </button>
                  </div> */}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
